export const SIGN_UP_COMPLETED = "project/users/signUpCompleted";
export const LOGIN_COMPLETED = "project/users/loginCompleted";
export const LOGOUT = "project/users/logout";
export const UPDATE_PROFILE_COMPLETED = "project/users/updateProfileCompleted";
export const ADD_IMAGE_COMPLETED = "project/users/addImageCompleted";
export const GET_USER_POINTS_COMPLETED = "project/users/getUserPointsCompleted";
export const GET_USER_RANKING_COMPLETED = "project/users/GET_USER_RANKING_COMPLETED";
export const REQUEST_PASSWORD_RESET_COMPLETED = "project/users/requestPasswordResetCompleted";
export const RESET_PASSWORD_COMPLETED = "project/users/resetPasswordCompleted";
